import { render, staticRenderFns } from "./user-impersonation.vue?vue&type=template&id=2b491e29&scoped=true&"
import script from "./user-impersonation.vue?vue&type=script&lang=js&"
export * from "./user-impersonation.vue?vue&type=script&lang=js&"
import style0 from "./user-impersonation.vue?vue&type=style&index=0&id=2b491e29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b491e29",
  null
  
)

export default component.exports